import styled from 'styled-components';
import { headline3 } from '../../styles/text';

const CardTitle = styled.div`
  ${headline3}
  padding: 0 0 10px 0;
`;

export default CardTitle;
